import { Link, useRouteLoaderData } from '@remix-run/react';
import { PhoneCalling } from '@solar-icons/react';
import { useTranslation } from 'react-i18next';

import type { loader as rootLoader } from '~/root';

interface ContactProps {
  isFullVersion?: boolean;
}

const Contact = ({ isFullVersion }: ContactProps) => {
  const { t } = useTranslation();
  const rootData = useRouteLoaderData<typeof rootLoader>('root');

  /* TODO: get from API */
  const phoneNumber = rootData?.storePhone;
  const phoneHref = `tel:${rootData?.storePhone?.replace(/\s+/g, '')}`;
  const imageSrc = '/assets/images/header_contact.webp';
  const openingHoursText = t('footer.store_hours');
  const className = isFullVersion ? 'd-block' : 'd-none d-lg-block';

  return (
    <div
      className={`${isFullVersion ? 'header-contact header-contact--full' : 'header-contact'} d-flex align-items-center position-relative`}
    >
      <span className={`header-contact__image ${isFullVersion ? 'position-relative' : ''}`}>
        <img
          src={imageSrc}
          alt={t('customer_service')}
          className={className}
          loading="eager"
          fetchpriority="low"
          decoding="async"
          width={48}
          height={48}
        />
      </span>

      <span>
        <Link className={className} to={phoneHref} aria-label={t('customer_service')}>
          {phoneNumber}
        </Link>
        {!isFullVersion && (
          <Link className="d-block d-lg-none" to={phoneHref} aria-label={t('customer_service')}>
            <PhoneCalling size={24} color="#000" />
          </Link>
        )}
        <span className={`header-contact__opening ${className}`}>({openingHoursText})</span>
      </span>
    </div>
  );
};

export default Contact;
